import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';

import { notification } from 'antd';
import { CustomerSource } from 'src/types/common.types';

const fetchCustomerSources = async () => {
  const response = await ApiService.get<CustomerSource[]>('/api/categories/sources');
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy danh sách nguồn khách hàng',
    });
    return [];
  }
  return data;
};

const useCustomerSources = () => {
  return useQuery({
    queryKey: ['customer-sources'],
    queryFn: () => fetchCustomerSources(),
    staleTime: 0,
  });
};

export default useCustomerSources;
